module.exports = __webpack_public_path__ + "static/media/Techno Dj.2aa1fae1.jpg";